/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ButtonName, LinkType, SectionName } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import PillIcon from 'bundles/front-page/redesign-modules/domains/PillIcon';
import Pill from 'bundles/unified-common/components/pill/Pill';
import type { Domain } from 'bundles/unified-common/types/domain';

const styles = {
  pill: css`
    white-space: nowrap;
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
    transform: translateZ(0);

    &:hover {
      box-shadow: 0 0 6px -4px var(--cds-color-darken-200), 0 0 8px -6px var(--cds-color-darken-200);
      transform: scale3d(1.01, 1.01, 1.01) translate3d(1px, -1px, 16px);
      text-decoration: none;
      color: var(--cds-color-neutral-primary) !important;
      border: 1px solid var(--cds-color-neutral-stroke-primary-weak) !important;
    }
  `,
};

const DomainPill = (props: Domain) => {
  const { id, name } = props;
  const slug = 'slug' in props ? props.slug : undefined;
  const hrefProp = 'href' in props ? props.href : undefined;

  const track = useTracker();

  const href = hrefProp || `/browse/${slug || ''}`;

  const trackingData = {
    button: {
      name: 'lohp_browse_domain' satisfies ButtonName,
      linkType: 'internal' satisfies LinkType,
      linkName: slug || id,
      linkURL: href,
    },
    pageSection: {
      sectionName: 'browse_domains' satisfies SectionName,
    },
  } as const;

  const handleClick = () => {
    track('click_button', trackingData);
  };

  const visibilityTrackingRef: React.MutableRefObject<HTMLAnchorElement | null> = useVisibilityTracker(
    'view_button',
    trackingData,
    [],
    { fullyVisible: true }
  );

  return (
    <Pill href={href} css={styles.pill} onClick={handleClick} ref={visibilityTrackingRef}>
      <PillIcon id={id} />
      {name}
    </Pill>
  );
};

export default DomainPill;
